import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PhotographicConsent } from '../Models/photographicconsent.model';

@Injectable({
  providedIn: 'root',
})
export class PhotographicConsentService {
  url = environment.Url + 'PhotographicConsents';

  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });

  constructor(private http: HttpClient) {}

  registerPhotographicConsent(body) {
    return this.http
      .post<PhotographicConsent>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  getPhotographicConsents() {
    return this.http
      .get<PhotographicConsent[]>(this.url)
      .pipe(catchError(this.handleError));
  }
  getPhotographicConsentById(id) {
    return this.http.get<PhotographicConsent>(this.url + '/' + id);
  }

  updatePhotographicConsent(id, body) {
    return this.http
      .put<PhotographicConsent>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deletePhotographicConsent(id) {
    return this.http
      .delete<PhotographicConsent>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid username or password');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
